import {
  CssBaseline,
  ThemeProvider,
  Box,
  Drawer,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Stack,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import StoreIcon from "@mui/icons-material/Store";
import InventoryIcon from "@mui/icons-material/Inventory";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import InfoIcon from "@mui/icons-material/Info";
import { useState } from "react";
import "./App.css";

import ShopPage from "./pages/ShopPage";
import SettingsPage from "./pages/SettingsPage";
import InventoryPage from "./pages/InventoryPage";
import ReportsPage from "./pages/ReportsPage";
import { SettingsProvider } from "./contexts/SettingsContext";
import AboutPage from "./pages/AboutPage";

const theme = createTheme({
  // You can customise your theme here
  // Start Generation Here
  palette: {
    primary: {
      main: "#20a6ab",
      contrastText: "#fff",
    },
  },

  components: {
    MuiToolbar: {
      styleOverrides: {
        dense: {
          height: 40,
          minHeight: 40,
        },
      },
    },
  },
});

function NavigationDrawer() {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const menuItems = [
    { text: "Shop", icon: <StoreIcon />, path: "/" },
    { text: "Inventory", icon: <InventoryIcon />, path: "/inventory" },
    { text: "Reports", icon: <AssessmentIcon />, path: "/reports" },
    { text: "Settings", icon: <SettingsIcon />, path: "/settings" },
    { text: "About", icon: <InfoIcon />, path: "/about" },
  ];

  const currentPath = useLocation().pathname;

  const currentMenuItem = menuItems.find((item) => item.path === currentPath);
  return (
    <>
      <AppBar position="static" variant="outlined">
        <Toolbar variant="dense">
          <IconButton
            color="inherit"
            onClick={() => setDrawerOpen(true)}
            edge="start">
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, fontSize: "20px" }}>
            {currentMenuItem?.text}
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 250 }} role="presentation">
          <List>
            {menuItems.map((item) => (
              <ListItemButton
                key={item.text}
                onClick={() => {
                  navigate(item.path);
                  setDrawerOpen(false);
                }}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
}

function App() {
  return (
    <SettingsProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Stack sx={{ height: "100vh" }} gap={1}>
            <NavigationDrawer />
            <Routes>
              <Route path="/" element={<ShopPage />} />
              <Route path="/inventory" element={<InventoryPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/about" element={<AboutPage />} />
            </Routes>
          </Stack>
        </BrowserRouter>
      </ThemeProvider>
    </SettingsProvider>
  );
}

export default App;
